export default "/images/video.png?825fa04ed0470feedc474ee57eb57f6a";